// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"pagenotfound_notFoundContainer__V6O1u","toHomeBtn":"pagenotfound_toHomeBtn__rWmnd"};